// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, checkingUser } = useAuth();
  const location = useLocation();

  if (checkingUser) {
    // Exibe um loader enquanto o estado de autenticação está sendo verificado
    return (
      <div className="loading-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Carregando...</p>
      </div>
    );
  }

  if (!user) {
    // Se não houver usuário, redireciona para o login, guardando a página que ele tentou acessar.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se o usuário estiver logado, renderiza o componente filho (a página protegida).
  return children;
};

export default ProtectedRoute;
